export default __webpack_public_path__ + "static/media/nasza_ksiegarnia.9d769186.png";